import React from 'react';

// A coded mockup of the real GRIDx client portal dashboard — same section
// labels and empty-state values the actual product shows before live data
// loads (Meter Units / Today's Net Usage / Current Power / Live Readings),
// not fabricated figures. Built as real markup, not a screenshot.
const DashboardMock = () => (
  <div className="gh-dash">
    <div className="gh-dash__topbar">
      <span className="gh-dash__brand">GRIDx</span>
      <span className="gh-dash__topbar-dot" />
    </div>
    <div className="gh-dash__cards">
      <div className="gh-dash__card">
        <span className="gh-dash__card-label">Meter Units</span>
        <span className="gh-dash__card-value">0 <small>kWh</small></span>
      </div>
      <div className="gh-dash__card">
        <span className="gh-dash__card-label">Today&apos;s Net Usage</span>
        <span className="gh-dash__card-value">0.00 <small>kWh</small></span>
      </div>
      <div className="gh-dash__card">
        <span className="gh-dash__card-label">Current Power</span>
        <span className="gh-dash__card-value">&#8212; <small>W</small></span>
      </div>
    </div>
    <div className="gh-dash__chart">
      <span className="gh-dash__card-label">Energy Consumption</span>
      <svg viewBox="0 0 200 50" preserveAspectRatio="none" className="gh-dash__sparkline">
        <polyline points="0,40 20,32 40,36 60,20 80,26 100,14 120,22 140,10 160,18 180,8 200,16" />
      </svg>
    </div>
    <div className="gh-dash__readings">
      <span className="gh-dash__card-label">Live Readings</span>
      {['Power', 'Voltage', 'Current', 'Frequency'].map((r) => (
        <div key={r} className="gh-dash__reading-row">
          <span>{r}</span>
          <span className="gh-dash__reading-value">&#8212;</span>
        </div>
      ))}
    </div>
  </div>
);

const PlatformSection = () => (
  <section className="gh-section gh-platform">
    <div className="gh-section__inner">
      <span className="eyebrow">Digital platform</span>
      <h2 className="gh-section__title">The interface behind the infrastructure.</h2>
      <p className="gh-section__sub">
        Every meter reports into the GRIDx client portal — real-time consumption,
        remote load control and token top-ups, on desktop and mobile alike.
      </p>

      <div className="gh-platform__devices">
        <div className="gh-device gh-device--laptop">
          <div className="gh-device__screen">
            <DashboardMock />
          </div>
          <div className="gh-device__base" />
        </div>
        <div className="gh-device gh-device--phone">
          <div className="gh-device__screen">
            <DashboardMock />
          </div>
        </div>
      </div>

      <ul className="gh-platform__points">
        <li>Real-time consumption tracking</li>
        <li>Remote load control</li>
        <li>Instant token top-ups</li>
        <li>Mobile and web access</li>
      </ul>
    </div>
  </section>
);

export default PlatformSection;
